import { ReactComponent as TwitterIcon } from '../svg/twitter.svg';
import { ReactComponent as LinkedinIcon } from '../svg/linkedin.svg';
import './styles/TeamCard.scss';
import { useState } from 'react';
import { AdvancedImage } from '@cloudinary/react';
import useGetCloudImage from '../hooks/useGetCloudImage';

const teamCloudURL = 'v1650747054/Paribus/Team/';

function TeamCard(props) {
    const {
        name,
        picture,
        role,
        bio,
        twitter,
        linkedin,
    } = props;

    const [openBio, setOpenBio] = useState(false);

    const cloudProfilePic = useGetCloudImage(teamCloudURL + picture);

    const isActive = openBio ? 'active' : '';

    return (
      <div className={'peopleCardWrapper ' + isActive} key={name}>
        <div className="peopleCard">
          <div className="peopleIcon">
            <AdvancedImage cldImg={cloudProfilePic} />
          </div>
          <div className="peopleContent">
            <p className='name'>{name}</p>
            <p className='status'>{role}</p>
            <p className='bio'>
             {bio}
            </p>
            <div className="social">
              {twitter && <a href={twitter} target="blank">
                <TwitterIcon />
              </a>}
              {linkedin && <a href={linkedin} target="blank">
                <LinkedinIcon />
              </a>}
              {bio && <span onClick={() => setOpenBio(!openBio)} className="seeBio"> see bio </span>}
            </div>
          </div>
        </div>
      </div>
    )
}

export default TeamCard;